import { createTheme } from '@mui/material';
import type {
  Theme as AugmentedTheme,
  ThemeOptions as AugmentedThemeOptions,
} from '@mui/material/styles';

import { aspectRatio } from './values/aspectRatio';
import { brandColors } from './values/brandColors';
import { brandType } from './values/brandType';
import { breakpoints } from './values/breakpoints';
import { components } from './values/components';
import { fontWeights } from './values/fontWeights';
import { palette } from './values/palette';
import { spacing } from './values/spacing';
import { type } from './values/type';
import { typography } from './values/typography';
import { zLevels } from './values/zLevels';

const SunrunThemeOptions: AugmentedThemeOptions = {
  palette,
  typography,
  components,
  fontWeights,
  brandColors,
  brandType,
  breakpoints,
  type,
  spacing,
  zLevels,
  aspectRatio,
};

export const SunrunTheme = createTheme(SunrunThemeOptions);
export type ThemeType = AugmentedTheme;
